document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('custom_contact_form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    let valid = true;

    // Champs requis
    form.querySelectorAll('input[required]').forEach(input => {
      const errorSpan = input.parentElement.querySelector('.contact-form__error');
      if (!input.checked && (input.type === 'checkbox' || input.value.trim() === '')) {
        valid = false;
        if (errorSpan) errorSpan.style.display = 'block';
      } else {
        if (errorSpan) errorSpan.style.display = 'none';
      }
    });

    if (!valid) e.preventDefault();
  });

  // Format code postal (ex: G1L 2P3)
  const postal = document.getElementById('contact_postal_code');
  if (postal) {
    postal.addEventListener('input', function() {
      let value = postal.value.toUpperCase().replace(/\s+/g, '');
      if (value.length > 3) value = value.slice(0,3) + ' ' + value.slice(3);
      postal.value = value;
    });
  }
});
